import { r as registerInstance, h, H as Host } from './index-8f7fb048.js';

const marketAccessoryCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;justify-content:center;align-items:center}:host([size='icon']){width:var(--accessory-icon-variant-size);height:var(--accessory-icon-variant-size)}:host([size='image']){width:var(--accessory-image-variant-size);height:var(--accessory-image-variant-size)}:host ::slotted(.market-icon){}:host ::slotted(img){-o-object-fit:cover;object-fit:cover;width:100%;height:100%}:host([size='icon']) ::slotted(img){border-radius:var(--accessory-icon-variant-border-radius)}:host([size='image']) ::slotted(img){border-radius:var(--accessory-image-variant-border-radius)}";

const MarketAccessory = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.size = undefined;
  }
  /* TODO: add optional height/width props for custom sizing of slotted image */
  render() {
    return (h(Host, { class: "market-accessory", size: this.size }, h("slot", null)));
  }
};
MarketAccessory.style = marketAccessoryCss;

export { MarketAccessory as market_accessory };
